import reduxConnector from 'root/src/shared/util/reduxConnector'

import displayNameSelector from 'root/src/client/logic/assignee/selectors/displayNameSelector'
import mnemonicIdSelector from 'root/src/client/logic/assignee/selectors/mnemonicIdSelector'
import platformSelector from 'root/src/client/logic/assignee/selectors/platformSelector'
import imageSelector from 'root/src/client/logic/assignee/selectors/imageSelector'
import followerCountSelector from 'root/src/client/logic/assignee/selectors/followerCountSelector'
import creatorDataSelector from 'root/src/client/logic/assignee/selectors/creatorDataSelector'

import completedProjectsSelector from 'root/src/client/logic/assignee/selectors/completedProjectsSelector'

export default reduxConnector(
	[
		['mnemonicId', mnemonicIdSelector],
		['platform', platformSelector],
		['displayName', displayNameSelector],
		['image', imageSelector],
		['followerCount', followerCountSelector],
		['completedProjects', completedProjectsSelector],
		['creatorData', creatorDataSelector],
	],
	[],
)
